"use strict";

import React from "react";
import TeamFormScreen from "./TeamFormScreen";

const TeamCreateScreen = () => {
    return <TeamFormScreen mode="create" />;
};

export default TeamCreateScreen;
